<template>
<!--交卷-->
  <div id="examsubmit">
    <div class="popup">
      <h3>是否确认交卷？</h3>
      <div class="sub">
        <a @click="submitAnswer()">确认</a>
        <a @click="submitClose()">取消</a>
      </div>
      <a class="close" @click="submitClose()">&times;</a>
    </div>
    <div class="bg" @click="submitClose()"></div>
  </div>
</template>

<script>
export default {
  name: 'WrongSubmit',
  data () {
    return {
    }
  },
  props: [
    'recordId',
    'recordType'
  ],
  methods: {
    submitClose () {
      this.$emit('listenSubmit')
    },
    submitAnswer () {
      let data = {
        record_id: this.recordId
      }
      this.$axios({
        method: 'POST',
        url: '/api/app/v1/post_wrong_question_test_paper',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.$router.push({name: 'WrongBank', query: {score: res.data.data.score}})
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style scoped lang="stylus">
  #examsubmit
    h2.title
      position: relative
      height: 1.08rem
      line-height: .8rem
      background-color: transparent
      padding: .14rem .16rem
      font-size: .32rem
      color: #A3A9B7
      font-weight: 600
      text-align: center
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      b
        font-size: .48rem
        color: #FF7052
      a.prev
        position: absolute
        top: .14rem
        left: .16rem
        display: block
        width: .8rem
        height: .8rem
        background-color: transparent
        -webkit-border-radius: 50%
        -moz-border-radius: 50%
        border-radius: 50%
        &::before
          content: ""
          position: absolute
          top: .3rem
          left: .32rem
          display: block
          width: .20rem
          height: .20rem
          border-left: .03rem solid #050505
          border-bottom: .03rem solid #050505
          -webkit-transform: rotate(45deg)
          -moz-transform: rotate(45deg)
          -ms-transform: rotate(45deg)
          -o-transform: rotate(45deg)
          transform: rotate(45deg)
      .right
        position: absolute
        top: .3rem
        right: .4rem
        display: flex
        justify-content: space-between
        align-items: center
        width: 2.2rem
        height: .62rem
        a
          display: block
          width: .7rem
          line-height: .3rem
          height: 100%
          font-size: .22rem
          color: #333
          text-align: center
          img
            display: block
            width: .24rem
            height: .22rem
            margin: 0 auto .02rem
    h3.type
      padding: 0 .4rem
      margin: .3rem 0
      font-size: .48rem
      color: #050505
      font-weight: 600
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
    .question
      padding: 0 .4rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      .title
        font-size: .32rem
        color: #333
        text-align: left
        font-weight: 500
      .choice
        dl
          display: flex
          justify-content: space-between
          align-items: center
          margin-top: .4rem
          dt
            display: block
            width: .64rem
            height: .64rem
            i
              display: block
              width: .64rem
              height: .64rem
              line-height: .64rem
              border: .02rem solid #ccc
              font-size: .32rem
              color: #ccc
              text-align: center
              -webkit-box-sizing: border-box
              -moz-box-sizing: border-box
              box-sizing: border-box
              -webkit-border-radius: 50%
              -moz-border-radius: 50%
              border-radius: 50%
            input
              display: none
            input:checked + i
              border-color: #FF7052
              background-color: #FF7052
              color: #fff
          dd
            width: 5.8rem
            font-size: .28rem
            color: #999
    .question + hr
      width: 6.7rem
      height: .02rem
      background-color: #CFD1D4
      border: none
      margin: .6rem auto 0
    .analysis
      padding: 0 .4rem
      margin-top: .38rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      h4
        font-size: .28rem
        color: #FF7052
        text-align: left
      dl.key
        margin: .36rem 0 0
        dt
          display: inline-block
          font-size: .32rem
          color: #050505
          font-weight: 600
        dd
          display: inline-block
          font-size: .32rem
          color: #FF7052
      dl.detail
        margin: .2rem 0 0
        dt
          font-size: .32rem
          color: #050505
          font-weight: 600
        dd
          p
            margin: .2rem 0 0
            font-size: .28rem
            color: #666
    .popup
      position: fixed
      top: 50%
      left: 50%
      z-index: 100
      width: 5.2rem
      height: 2.4rem
      background-color: #fff
      -webkit-border-radius: .16rem
      -moz-border-radius: .16rem
      border-radius: .16rem
      -webkit-transform: translate(-50%, -50%)
      -moz-transform: translate(-50%, -50%)
      -ms-transform: translate(-50%, -50%)
      -o-transform: translate(-50%, -50%)
      transform: translate(-50%, -50%)
      h3
        margin: .48rem 0 .32rem
        font-size: .32rem
        color: #333
        text-align: center
      .sub
        display: flex
        justify-content: space-between
        width: 3.76rem
        height: .68rem
        margin: .42rem auto
        a
          display: inline-block
          width: 1.64rem
          height: .68rem
          line-height: .64rem
          border: .02rem solid #FF7052
          font-size: .36rem
          color: #FF7052
          text-align: center
          -webkit-box-sizing: border-box
          -moz-box-sizing: border-box
          box-sizing: border-box
          -webkit-border-radius: .4rem
          -moz-border-radius: .4rem
          border-radius: .4rem
          &:first-child
            background-color: #FF7052
            color: #fff
      a.close
        position: absolute
        top: .2rem
        right: .2rem
        display: block
        width: .3rem
        height: .3rem
        line-height: .24rem
        font-size: .4rem
        text-align: center
    .bg
      position: fixed
      top: 0
      left: 0
      z-index: 50
      width: 100%
      height: 100%
      background-color: rgba(0, 0, 0, .4)

</style>



// WEBPACK FOOTER //
// src/components/exam/WrongSubmit.vue